import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Styles/Styles.css"
import "react-toastify/dist/ReactToastify.css";
import App, { protectedRoutes } from "./App";
import './i18n'
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./Store/store";
import { setupSessionExpiry } from "./Utils/sessionExpiry";

setupSessionExpiry(persistor, protectedRoutes);


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
